<template>
  <div class="dialog-content">
    <img
      src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E5%85%B3%E9%97%AD%402x.png"
      class="closedialog"
      alt=""
      @click="$emit('close')"
    />
    <div class="zzym">制种玉米</div>
    <div class="info">
      <div class="flex">
        <div class="">
          <div class="cont1 flexCol alit justc">
            <img
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E7%8E%89%E7%B1%B3%402x.png"
              alt=""
            />
          </div>
          <div class="cont-title">气候适宜</div>
          <div class="cont2">
            张掖位于河西走廊中部，属温带大陆性气候，光照充足、昼夜温差大、降水稀少但灌溉便利。有利于玉米光合作用和干物质积累，同时减少病虫害发生，为制种玉米提供了理想的生长环境。
          </div>
          <div class="cont-title">土壤肥沃</div>
          <div class="cont2">
            地处绿洲平原，土壤以灌淤土和栗钙土为主，土层深厚、有机质含量高，且长期灌溉形成良好的水肥条件，适合玉米连作和规模化种植。
          </div>
          <div class="cont-title">隔离条件优越</div>
          <div class="cont2">
            河西走廊地势狭长，四周被沙漠、山脉环绕，天然隔离条件好，可有效防止外来花粉污染，保证制种玉米的纯度。
          </div>
        </div>
        <div class="">
          <div class="cont-title" style="margin-top: 0">隔离条件优越</div>
          <div class="flex justb">
            <div class="national-count flexCol alit justc">
              <div class="count-title">年制总面积（万亩）</div>
              <div class="count-num">100+</div>
            </div>
            <div class="national-count flexCol alit justc">
              <div class="count-title">全国年制总面积 (万亩)</div>
              <div class="count-num">250+</div>
            </div>
            <div class="national-count flexCol alit justc">
              <div class="count-title">张掖占比</div>
              <div class="count-num">40%</div>
            </div>
            <div class="national-count flexCol alit justc">
              <div class="count-title">甘州区占比</div>
              <div class="count-num">15%</div>
            </div>
          </div>
          <div class="cont-title">中国玉米制种第一市</div>
          <div class="flex justb" style="margin-top: 20px">
            <div class="flexCol alit">
              <div class="china-num">100万吨+</div>
              <div class="china-title">年制总产量</div>
            </div>
            <div class="flexCol alit">
              <div class="china-num">100万吨+</div>
              <div class="china-title">全国年制总产量</div>
            </div>
            <div class="flexCol alit">
              <div class="china-num">50%</div>
              <div class="china-title">张掖占比</div>
            </div>
            <div class="flexCol alit">
              <div class="china-num">21%</div>
              <div class="china-title">甘州区占比</div>
            </div>
          </div>
          <div class="cont-title">种植“四统一”</div>
          <div
            class="flex justb"
            style="flex-wrap: wrap; width: 95%; margin-left: 15px"
          >
            <div class="ty-style">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/1.png"
                alt=""
              />
              <div class="bz">发芽率 ≥ 90%</div> 
              <div class="ty-title">统一供种</div>
            </div>
            <div class="ty-style">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/2.png"
                alt=""
              />
              <div class="bz">节水 ≥ 60%</div>
              <div class="ty-title">统一灌溉</div>
            </div>
            <div class="ty-style">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/3.png"
                alt=""
              />
              <div class="bz">纯度 ≥ 99.9%</div>
              <div class="ty-title">统一去雄</div>
            </div>
            <div class="ty-style">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/4.png"
                alt=""
              />
              <div class="bz">籽粒含水量 ≤ 13%</div>
              <div class="ty-title">统一收获</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.info {
  width: 1160px;
  height: 680px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E5%BC%B9%E7%AA%97%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
  margin-top: -2px;
  padding: 20px;
  .ty-style {
    width: 291px;
    height: 141px;
    position: relative;
    margin-top: 30px;
    img {
      width: 291px;
      height: 141px;
      border-radius: 5px;
    }
    .ty-title {
      width: 30px;
      height: 90px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E5%9B%9B%E7%BB%9F%E4%B8%80%E6%A0%87%E9%A2%98%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 100%;
      position: absolute;
      top: 20px;
      left: -15px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      line-height: 15px;
      text-align: center;
      line-height: 30px;
      letter-spacing: 6px;
      writing-mode: vertical-rl; /* 垂直从右到左 */
      text-orientation: upright; /* 文本方向 */
    }
    .bz {
      position: absolute;
      bottom: 0;
      background: rgba(0, 63, 140, 0.78);
      height: 22px;
      width: 291px;

      font-weight: 500;
      font-size: 10px;
      color: #fab040;
      line-height: 22px;
      text-align: center;
    }
  }
  .china-title {
    width: 105px;
    height: 63px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E5%88%B6%E7%A7%8D%E8%83%8C%E6%99%AF%E4%BF%A1%E6%81%AF2%402x.png");
    background-size: 100% 100%;

    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 103px;
    text-align: center;
    margin-top: -35px;
  }
  .china-num {
    height: 72px;
    width: 72px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E5%88%B6%E7%A7%8D%E4%BF%A1%E6%81%AF%E8%83%8C%E6%99%AF1%402x.png");
    background-size: 100% 100%;
    font-family: YouSheBiaoTiHei;
    font-size: 18px;
    color: #00ffd8;
    font-style: normal;
    text-align: center;
  }
  .national-count {
    width: 134px;
    height: 87px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E6%A0%B8%E5%BF%83%E5%8C%BA%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;

    .count-title {
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
    }

    .count-num {
      font-family: YouSheBiaoTiHei;
      font-size: 18px;
      color: #ffac0b;
      line-height: 12px;
      margin-top: 13px;
    }
  }
  .cont-title {
    width: 227px;
    height: 28px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E6%A0%87%E9%A2%98%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    padding-left: 30px;
    font-family: YouSheBiaoTiHei;
    font-size: 18px;
    color: #ffffff;
    line-height: 28px;
    letter-spacing: 1px;
    margin-top: 20px;
  }
  .cont2 {
    width: 477px;
    height: 93px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E7%AE%80%E4%BB%8B%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    padding: 10px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    line-height: 30px;
  }
  .cont1 {
    width: 470px;
    height: 198px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/%E5%B7%A6%E4%B8%8A%E8%83%8C%E6%99%AF%402x%20%281%29.png");
    background-size: 100% 100%;
    img {
      width: 97px;
      height: 159px;
    }
  }
}
.zzym {
  width: 1200px;
  height: 65px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%88%B6%E7%A7%8D%E7%8E%89%E7%B1%B3/title%402x.png");
  background-size: 100% 100%;

  font-family: YouSheBiaoTiHei;
  font-size: 26px;
  color: #ffffff;
  line-height: 65px;
  letter-spacing: 1px;
  text-align: center;
}
.closedialog {
  position: absolute;
  top: 20px;
  right: 50px;
  z-index: 9999;
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.dialog-content {
  z-index: 9999;
  position: relative;
}
</style>